import { jwtDecode } from 'jwt-decode';

/** Role from the stored JWT ('ADMIN' | 'STAFF' | ...), or null when logged out / unreadable. */
export const getCurrentRole = () => {
  try {
    const token = localStorage.getItem('token');
    return token ? jwtDecode(token).role || null : null;
  } catch (e) {
    return null;
  }
};
